import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '4px',
    padding: '4px',
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
  },

  rowTotalHrs: {
    fontSize: '0.55rem',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
